export default __webpack_public_path__ + "static/cyclists-f11eb94a476202c92792ad4a03c27676.png";